<div class=""
     *ngIf="(!isPopup && popupInfo.show) || isPopup"
     [class.is-active]="popupInfo.show && isPopup"
     [class.investments-popup.investments-popup--pay]="isPopup">
    <div class="investments-popup__inner"
         [class.investments-popup__inner]="isPopup">
        <button class="investments-popup__close"
                (click)="closePopup()"
                *ngIf="isPopup"></button>
        <div class="investments-popup__title">
            <ng-container *ngIf="isEntireBalance()">
              {{'withdrawData' | languageTranslate: [{$innerVariable: 'entireBalanceTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.venmo && popupInfo.venmoAddress">
<!--                Withdraw to Venmo-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'venmoTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.paypal && popupInfo.paypalAddress">
<!--                Withdraw to PayPal-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'payPalTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.card">
<!--                Withdraw to your Debit Card-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'debitCardTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.cashapp">
<!--                Withdraw to Cash App Account-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'cashAppAccountTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.bankAccount">
<!--                Withdraw to your Bank Account-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'bankAccountTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.giftCardAmazon">
<!--                Get Amazon Gift Card-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'amazonGiftCardTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.giftCardVisa">
<!--                Get Visa Card-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'visaCardTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.cashappBitcoin">
              {{'withdrawData' | languageTranslate: [{$innerVariable: 'cashAppBitcoinTitle'}]}}
            </ng-container>

            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.paypalPYUSD">
              {{'withdrawData' | languageTranslate: [{$innerVariable: 'paypalCryptoTitle'}]}}
            </ng-container>

<!--            <ng-container *ngIf="popupInfo.type === PRIZES_METHODS.paynote">-->
<!--&lt;!&ndash;                Withdraw to {{popupInfo.paynoteTitle}}&ndash;&gt;-->
<!--                {{'withdrawData' | languageTranslate: [{$innerVariable: 'paynoteTitle', paynoteTitle: popupInfo.paynoteTitle}]}}-->
<!--            </ng-container>-->
        </div>
        <div class="investments-popup__scrolled">
            <ng-container *ngIf="(popupInfo.type === PRIZES_METHODS.topUpBalance) && !isEntireBalance()">
                <p style="text-align: center">
                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'topUpTitle'}]}}
                </p>
            </ng-container>
            <div class="investments-popup__title-pay">

                <p *ngIf="popupInfo.type !== PRIZES_METHODS.paypal && popupInfo.type !== PRIZES_METHODS.venmo &&
                          popupInfo.type !== PRIZES_METHODS.card && !isOneOfGiftCards()">
                    {{popupInfo.popupTitle}}
                </p>

                <p *ngIf="popupInfo.type === PRIZES_METHODS.paypal && !popupInfo.paypalAddress">
<!--                    Please enter the email account registered with your PayPal. Only ONE PayPal email is allowed per active account.-->
                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'askEnterPayPalEmail'}]}}
                </p>
                <p *ngIf="popupInfo.type === PRIZES_METHODS.paypal && popupInfo.paypalAddress">
<!--                    You opted to withdraw via PayPal. Your money will be sent via {{popupInfo.handle}}. If your PayPal email has changed, please contact support before transferring your funds or risk loosing it.-->
<!--                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'askEnterPayPalEmail', handle: popupInfo.handle}]}}-->
                    {{popupInfo.text}}
                </p>

                <p *ngIf="popupInfo.type === PRIZES_METHODS.venmo && !popupInfo.venmoAddress">
<!--                    Please enter the Phone Number registered with your Venmo. Only ONE Venmo Phone Number is allowed per active account.-->
                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'askEnterVenmoPhone'}]}}
                </p>
                <p *ngIf="popupInfo.type === PRIZES_METHODS.venmo && popupInfo.venmoAddress">
<!--                    {{'formData' | languageTranslate: [{$innerVariable: 'phone'}]}} {{popupInfo.handle | mask: phoneMask}} {{'withdrawData' | languageTranslate: [{$innerVariable: 'willAssociatedWithVenmo'}]}}-->
                    {{popupInfo.text}}
                </p>

                <p *ngIf="popupInfo.type === PRIZES_METHODS.card">
<!--                    You opted to withdraw directly to your debit card. Enter the amount and click Continue.-->
<!--                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'optedToWithdrawDebitCard'}]}}-->
                    {{popupInfo.text}}
                </p>

<!--                <p *ngIf="popupInfo.type === PRIZES_METHODS.cashapp">-->
<!--&lt;!&ndash;                    You opted to withdraw to your Cash App Account. The money will be sent directly to your Cash App bank account. Enter the amount and click Continue.&ndash;&gt;-->
<!--                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'optedToWithdrawCashApp'}]}}-->
<!--                </p>-->

                <p *ngIf="popupInfo.type === PRIZES_METHODS.bankAccount">
<!--                    You opted to withdraw to your Bank Account. The money will be sent directly to your Bank Account. Enter the amount and click Continue.-->
                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'optedToWithdrawBankAccount'}]}}
                </p>

<!--                <p *ngIf="popupInfo.type === PRIZES_METHODS.paynote">-->
<!--&lt;!&ndash;                    You opted to withdraw to Paynote.&ndash;&gt;-->
<!--                    {{'withdrawData' | languageTranslate: [{$innerVariable: 'optedToWithdrawPaynote'}]}}-->
<!--                </p>-->

                <p *ngIf="isOneOfGiftCards()">
                    {{popupInfo.giftDescription}}
                </p>

              <p *ngIf="popupInfo.type === PRIZES_METHODS.cashappBitcoin">
                <!--                    You opted to withdraw to your Bank Account. The money will be sent directly to your Bank Account. Enter the amount and click Continue.-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'cashAppBitcoinText'}]}}
              </p>

              <p *ngIf="popupInfo.type === PRIZES_METHODS.paypalPYUSD">
                <!--                    You opted to withdraw to your Bank Account. The money will be sent directly to your Bank Account. Enter the amount and click Continue.-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'paypalCryptoText'}]}}
              </p>

              <p *ngIf="isEntireBalance()">
                <!--                    You opted to withdraw to your Bank Account. The money will be sent directly to your Bank Account. Enter the amount and click Continue.-->
                {{'withdrawData' | languageTranslate: [{$innerVariable: 'entireBalanceText'}]}}
              </p>

                <div *ngIf="popupInfo.type === PRIZES_METHODS.card || popupInfo.type === PRIZES_METHODS.bankAccount || popupInfo.type === PRIZES_METHODS.cashapp">
                    <div class="c-accent"  style="opacity: 1; display: flex; justify-content: space-between; margin: 1rem 0">
                        <div>{{popupInfo.handle}}</div>
                        <button class="edit-card-btn" id="editPopupBtn" [attr.popup-type]="popupInfo.type">
                            {{'edit' | languageTranslate}}
                            <svg>
                                <use [attr.xlink:href]="'../../../../assets/images/sprite.svg#pencil'"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <div class="page__form group-bordered-inner" *ngIf="popupInfo.type === PRIZES_METHODS.paypal && !popupInfo.paypalAddress">
                <app-verify-cashapp-tag [isPaypal]="true"  [verifyStatus]="popupInfo.paypalAddress" (onVerify)="setPaypalVerified($event)"></app-verify-cashapp-tag>
            </div>

            <div class="page__form group-bordered-inner" *ngIf="popupInfo.type === PRIZES_METHODS.venmo && !popupInfo.venmoAddress">
                <app-verify-cashapp-tag [isVenmo]="true" [isVenmoPhone]="true"  [verifyStatus]="popupInfo.venmoAddress" (onVerify)="setVenmoVerified($event)"></app-verify-cashapp-tag>
            </div>

            <form [formGroup]="form"
                  (ngSubmit)="onSubmitForm()"
                  *ngIf="(popupInfo.type === PRIZES_METHODS.paypal && popupInfo.paypalAddress) ||
                     (popupInfo.type === PRIZES_METHODS.venmo && popupInfo.venmoAddress) ||
                     (popupInfo.type !== PRIZES_METHODS.paypal && popupInfo.type !== PRIZES_METHODS.venmo)"
                  class="form-simple form-simple--shrink form-simple--primary">

                <div class="form-simple__item"
                     *ngIf="(popupInfo.type !== PRIZES_METHODS.venmo) &&
                            (popupInfo.type !== PRIZES_METHODS.paypal) &&
                            (popupInfo.type !== PRIZES_METHODS.card) &&
                            (popupInfo.type !== PRIZES_METHODS.bankAccount) &&
                            (popupInfo.type !== PRIZES_METHODS.cashapp) &&
                            (popupInfo.type !== PRIZES_METHODS.paynote) &&
                            (popupInfo.type !== PRIZES_METHODS.cashappBitcoin) &&
                            (popupInfo.type !== PRIZES_METHODS.paypalPYUSD) &&
                            !isEntireBalance()">
                    <input formControlName="handle"
                           placeholder="{{'formData' | languageTranslate: [{$innerVariable: 'handle'}]}}"
                           disabled="true"
                           [type]="'text'"
                           [value]="popupInfo.handle"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item"
                     *ngIf="(popupInfo.type === PRIZES_METHODS.paynote) || (popupInfo.type === PRIZES_METHODS.paypal)">
                    <div *ngIf="popupInfo.type === PRIZES_METHODS.paypal"
                         class="form-simple__item-label">
                        {{'enter' | languageTranslate | titlecase}} PAYPAL {{'formData' | languageTranslate: [{$innerVariable: 'email'}] | uppercase}}
                    </div>
                    <input formControlName="handle"
                           placeholder="{{'formData' | languageTranslate: [{$innerVariable: 'email'}]}}"
                           [type]="'text'"
                           required="true"
                           email="true"
                           [value]="popupInfo.handle"
                           class="form-simple__input"
                           autocomplete="off">
                </div>

                <div class="form-simple__item" *ngIf="popupInfo.type === PRIZES_METHODS.venmo && popupInfo.venmoAddress">
                    <div class="form-simple__item-label">
                        {{'enter' | languageTranslate | titlecase}} VENMO {{'formData' | languageTranslate: [{$innerVariable: 'phone'}] | uppercase}}
                    </div>
                    <input formControlName="phoneVenmo"
                           placeholder="{{'phoneNumber' | languageTranslate}}"
                           [mask]="phoneMask"
                           [type]="'tel'"
                           required="true"
                           class="form-simple__input"
                           autocomplete="off">
                </div>


<!--                <div class="form-simple__item" *ngIf="popupInfo.type === PRIZES_METHODS.games">-->
<!--                    <mat-form-field>-->
<!--                        <mat-select #methodsSelect-->
<!--                                    formControlName="handle"-->
<!--                                    [(value)]="selectedMethod" panelClass="my-select-panel-border-yellow">-->
<!--                            <mat-select-trigger>-->
<!--                                {{methodsSelect?.value?.name}}-->
<!--                            </mat-select-trigger>-->
<!--                            <mat-option *ngFor="let method of popupInfo.providers" [value]="method">-->
<!--                                {{method.name}}-->
<!--                            </mat-option>-->
<!--                        </mat-select>-->
<!--                    </mat-form-field>-->
<!--                </div>-->

                <div class="form-simple__item-label"
                     *ngIf="(popupInfo.type === PRIZES_METHODS.venmo) || (popupInfo.type === PRIZES_METHODS.paypal)">
                    {{'enter' | languageTranslate | titlecase}} {{'formData' | languageTranslate: [{$innerVariable: 'amount'}] | uppercase}}
                </div>
                <div class="form-simple__item form-simple__item--amount"
                     *ngIf="(isOneOfGiftCards() && popupInfo.giftAmountType === 'range') ||
                     (!isOneOfGiftCards() && !showCryptoContinueSession())">
                    <input mask="separator.0"
                           thousandSeparator=","
                           (input)="onInputAmount()"
                           formControlName="amount"
                           placeholder="{{'formData' | languageTranslate: [{$innerVariable: 'amount'}]}}"
                           [type]="'tel'"
                           class="form-simple__input"
                           autocomplete="off">
                    <span>.00</span>
                    <div class="page__form-note"
                         *ngIf="!isPaypalOrVenmo()"
                         [class.is-active]="moreThenAvailablePayout">
                        {{'available' | languageTranslate}} {{formatCurrency(popupInfo.totalDebit)}}
                    </div>
                    <div class="page__form-note"
                         *ngIf="isPaypalOrVenmo()"
                         [class.is-active]="moreThenAvailablePayout">
                        {{moreThenAvailableText}}
                    </div>
                </div>

                <div>
                    <div class="amount-variants" *ngIf="isOneOfGiftCards() && popupInfo.giftAmountType === 'fixed' && popupInfo.giftAmountArray">
                        <button class="amount-variants__item"
                                type="button"
                                [class.is-active]="form.controls.amount.value === item"
                                (click)="selectAmount(item)"
                                *ngFor="let item of popupInfo.giftAmountArray">{{item}}</button>
                    </div>
                </div>


                <div class="form-simple__item"  *ngIf="isOneOfGiftCards()">
                    <input mask="separator.0"
                           (input)="onInputQuantity()"
                           formControlName="quantity"
                           placeholder="{{'formData' | languageTranslate: [{$innerVariable: 'quantity'}]}}"
                           [type]="'tel'"
                           class="form-simple__input"
                           autocomplete="off">
                    <div style="margin-top: 1rem">
                        {{'totalAmount' | languageTranslate}}: {{formatCurrency(totalAmount)}}
                    </div>
                    <div class="page__form-note page__form-note--qty" [class.is-active]="!isTotalAmountCorrect && +form.controls.quantity.value">
                        {{'totalAmountNotMoreThanAvailable' | languageTranslate}} {{formatCurrency(popupInfo.totalDebit)}}
                    </div>
                </div>

<!--                <form [formGroup]="formDeliverySpeed" class="form-simple"-->
<!--                      *ngIf="isPaypalOrVenmo && showSameDay">-->
<!--                    <div class="check-radio-btns">-->
<!--                        <div class="check-radio-btns__item">-->
<!--                            <input type="radio"-->
<!--                                   formControlName="speed"-->
<!--                                   id="nextDay"-->
<!--                                   name="speed"-->
<!--                                   class="check-radio-btns__input"-->
<!--                                   value="nextDay"  checked/>-->
<!--                            <label for="nextDay" class="check-radio-btns__label">-->
<!--                                <span class="accent">{{'standard' | languageTranslate}}</span>: {{'theNextBusinessDay' | languageTranslate}} <br>-->
<!--                                <span class="small">{{'freeCharge' | languageTranslate}}</span>-->
<!--                            </label>-->
<!--                        </div>-->

<!--                        <div class="check-radio-btns__item">-->
<!--                            <input type="radio"-->
<!--                                   formControlName="speed"-->
<!--                                   id="sameDay"-->
<!--                                   name="speed"-->
<!--                                   class="check-radio-btns__input"-->
<!--                                   value="sameDay" />-->
<!--                            <label for="sameDay" class="check-radio-btns__label">-->
<!--                                <span class="accent">{{'expedited' | languageTranslate}}</span>: {{'theSameDay' | languageTranslate}} <br>-->
<!--                                <span class="small">{{'bankImposedFeesNoAmount' | languageTranslate: [{percent: deliveryPercent}]}}</span>-->
<!--                            </label>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <table class="amount-result">-->
<!--                        <tr class="amount-result__row">-->
<!--                            <td>Fees:</td>-->
<!--                            <td>-->
<!--                                <ng-container *ngIf="getFees()">-->
<!--                                    {{formatCurrency(getFees())}}-->
<!--                                </ng-container>-->
<!--                                <ng-container *ngIf="!getFees()">-->
<!--                                    {{'free' | languageTranslate | titlecase}}-->
<!--                                </ng-container>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                        <tr class="amount-result__row">-->
<!--                            <td>Total Due:</td>-->
<!--                            <td>{{formatCurrency(getTotal())}}</td>-->
<!--                        </tr>-->
<!--                    </table>-->
<!--                </form>-->
                <div class="form-simple__btns" *ngIf="showCryptoContinueSession()">
                  <button class="button"
                          (click)="continueCryptoSession()">
                    <!--                        Transfer-->
                    {{'cryptoSession' | languageTranslate: [{$innerVariable: 'btnWithdrawContinue'}]}}
                    <!--                        <svg><rect></rect></svg>-->
                  </button>
                  <button class="button"
                          (click)="initNewCryptoSession()">
                    <!--                        Transfer-->
                    {{'cryptoSession' | languageTranslate: [{$innerVariable: 'btnWithdrawNew'}]}}
                    <!--                        <svg><rect></rect></svg>-->
                  </button>
                </div>

                <div class="form-simple__btns" *ngIf="!showCryptoContinueSession()">
                    <button class="button"
                            [disabled]="+form.controls.amount.value <= 0 ||
                            (isOneOfGiftCards() && (!+form.controls.quantity.value || !isTotalAmountCorrect)) ||
                            ((popupInfo.type === PRIZES_METHODS.paypal) && (form.controls.handle.invalid || form.controls.amount.invalid || (+form.controls.amount.value < minAmount))) ||
                            ((popupInfo.type === PRIZES_METHODS.venmo) && (form.controls.phoneVenmo.invalid || form.controls.amount.invalid || (+form.controls.amount.value < minAmount))) ||
                            ((popupInfo.type === PRIZES_METHODS.paynote) && (form.controls.handle.invalid || form.controls.amount.invalid))">
<!--                        Transfer-->
                        {{'continue' | languageTranslate}}
<!--                        <svg><rect></rect></svg>-->
                    </button>
                </div>
            </form>
<!--            <button class=""-->
<!--                    (click)="closePopup()"-->
<!--                    *ngIf="!isPopup">Back</button>-->
            <button class="button button--reverse"
                    style="width: 100%; margin-top: 1rem"
                    type="button"
                    *ngIf="!isPopup"
                    (click)="closePopup()">
                {{'btnBack' | languageTranslate}}
            </button>
        </div>
    </div>
</div>
